import { useQuery } from '@tanstack/react-query';

import { sdk } from '@/services';

const ExamGroupService = sdk.getService('ExamGroupService');

export const useExamGroupOptionsPCE = () => {
  const { data, isLoading, error } = useQuery({
    queryKey: ['exam-groups', 'pce'],
    queryFn: () => ExamGroupService.getExamGroupsPCE()
  });
  return { data, isLoading, error };
};
